<style scoped>

.search-indicator{
  margin-top: 5px;
  text-align: center;
}
.create-group{
  background: #fff;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.create-group > .action-button{
  width: 100%;
}
</style>

<template>
  <div class="resource-list-item-component">
    <Card shadow :padding="10" :style="{borderRadius: '0'}" v-if="userStuffs.careplans > 0">
      <Input @on-change="debounceInput(searchValue)" v-model="searchValue"
        icon="ios-search" placeholder="Search"></Input>
      <p class="search-indicator" v-if="isLoadingSearch">Searching...</p>
    </Card>
    <div class="create-group" v-if="false">
      <Button type="default" icon="plus" class="action-button"
        v-on:click="reRouteCreateGroup">Create Group</Button>
    </div>
    <div class="resource-item-container">
      <div class="resource-body" v-for="(stuff, indx) in userStuffs.careplans" v-if="stuff.careplan.is_approved && stuff.careplan.type!='report_concern' && stuff.careplan.type!='suggestion_box' && stuff.careplan.type!='menu' && stuff.careplan.type!='video' && stuff.careplan.type!='maintainance'" :key="indx">
        <div v-if="!stuff.careplan">
          <FeedListView :avatar="groupDisplayImage(stuff)"
            :title="stuff.title"
            :item="stuff"
            :poster="stuff.careplan.type"
            @emitContainer="onTriggerStuff(stuff)"></FeedListView>
        </div>
        <div v-if="stuff.careplan">
          <div>
            <FeedListView :avatar="stuff.careplan.thumbnail_photo"
              :title="stuff.careplan.title"
              :item="stuff"
              :poster="stuff.careplan.type"
              @emitContainer="onTriggerStuff(stuff)"></FeedListView>
          </div>
        </div>
      </div>
    </div>
    <Spin style="margin: 20px 0;" v-if="isLoadingLoadMore">
      <Icon type="load-c" size=18 class="spinner-load"></Icon>
      <div>Loading</div>
    </Spin>
    <ContentLoading v-show="isLoadingMyStuff" :height="60" style="margin:0 10px 0 10px;" v-for="n in 5" :key="n">
      <circle cx="30" cy="30" r="25" />
      <rect x="75" y="13" rx="4" ry="4" width="300" height="15" />
      <rect x="75" y="37" rx="4" ry="4" width="200" height="10" />
    </ContentLoading>
  </div>
</template>

<script>
import FeedListView from "@/components/FeedListView";
import _ from "lodash";
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'
import Utils from '@/utils.js'
import ContentLoading from 'vue-content-loading';

export default {
  name: "ResourceListItemComponent",
  mixins: [WindowScrollEvent],
  components: {
    FeedListView, ContentLoading
  },
  data(){
    return {
      searchValue: '',
    }
  },
  computed: {
    userStuffs: {
      get() {
        return this.$store.state.publicProfile.myStuff.data;
      }
    },
    // profileInfo: {
    //   get() {
    //     return this.$store.state.user.info;
    //   }
    // },
    publicProfileInfo: {
      get() {
        return this.$store.state.publicProfile.info.data;
      }
    },
    isLoadingInfo: {
      get() {
        return this.$store.state.publicProfile.info.isLoading;
      }
    },
    isLoadingLoadMore: {
      get() {
        return this.$store.state.user.isLoadingLoadMore;
      }
    },
    isLoadingSearch: {
      get() {
        return this.$store.state.user.isLoadingSearch
      }
    },
    isLoadingMyStuff: {
      get() {
        return this.$store.state.publicProfile.myStuff.isLoading;
      }
    }
  },
  mounted() {
    // console.log('Groups')
  },
  methods: {
    groupDisplayImage(stuff) {
      return Utils.getDisplayImage('group', stuff, 'small')
    },
    onWindowScrolledBottom () {
    },
    onTriggerStuff(data) {
      // console.log('onTriggerStuff...', data);
      if(data.careplan_id) {
        // console.log('onTriggerStuff careplan_id...');
        this.$router.push({ path: "/resources/" + data.careplan_id });
      } else {
        // console.log('onTriggerStuff id...');
        this.$router.push({ path: "/resources/" + data.id });
      }
    },
    reRouteCreateGroup(){
      this.$router.push({ path: 'create-group' });
    },
    debounceInput: _.debounce(function (search_data) {
      this.$store.dispatch("user/serachUserStuffs", { journal_id: this.publicProfileInfo.journal_id, search: search_data })
    }, 500)
  }
};
</script>
